function ExpandIcon() {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.833496"
        y="1"
        width="63"
        height="63"
        rx="31.5"
        stroke="#FFF4E3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3335 25.5H39.3335V32.5H37.8335V27H32.3335V25.5ZM26.8335 32.5V38H32.3335V39.5H25.3335V32.5H26.8335Z"
        fill="#FFF4E3"
      />
    </svg>
  );
}

export default function ExpandButton({ onClick }: any) {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <ExpandIcon />
    </div>
  );
}
